/**
 * useCalendarEvents Hook
 *
 * Hook para buscar eventos do calendário com React Query
 */

import { useQuery } from '@tanstack/react-query';
import { calendarService } from '../services/calendarService';
import type { CalendarEventQuery } from '@troia-v3/types';

export const useCalendarEvents = (query?: CalendarEventQuery, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['calendar-events', query],
    queryFn: () => calendarService.getEvents(query),
    staleTime: 2 * 60 * 1000, // 2 minutes
    enabled: options?.enabled ?? true,
  });
};
